import { Component, OnInit } from '@angular/core';
import { DeviceBehfa_Cabinet_Interface, Empty_DeviceBehfa_Cabinet_Interface } from 'src/app/Interface/DeviceBehfa_Cabinet_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CabinetService } from 'src/app/Service/Cabinet/Cabinet.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CabinetView',
  templateUrl: './CabinetView.component.html',
  styleUrls: ['./CabinetView.component.scss']
})
export class CabinetViewComponent implements OnInit {
  Procssing: boolean = false
  DataList_Cabinet: Array<DeviceBehfa_Cabinet_Interface> = []
  Selected_DataList_Cabinet: DeviceBehfa_Cabinet_Interface = Empty_DeviceBehfa_Cabinet_Interface()
  Selected_DataList_Cabinet_Swicher:number=0

  constructor(
    private Cabinet_Service: CabinetService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Read_DeviceBehfa_Cabinet()
    this.Nav_Service.CheckValidPage(1155).subscribe(
      data => {
        setInterval(() => {
          if (!this.Procssing) {
            this.Read_DeviceBehfa_Cabinet()
          }

        }, 5*60*1000);

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  Read_DeviceBehfa_Cabinet() {
    this.Procssing=true
    this.Cabinet_Service.GetWatchViewer().subscribe(
      data=>{
        this.DataList_Cabinet=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set_DeviceBehfa_List(model: Array<DeviceBehfa_Interface>, item: DeviceBehfa_Cabinet_Interface, status: number)
  {
    this.DataList_DeviceBehfa=model
    this.Selected_DataList_Cabinet=item
    this.Selected_DataList_Cabinet_Swicher=status
  }

  Back_DeviceBehfa_List()
  {
    this.DataList_DeviceBehfa=[]
    this.Selected_DataList_Cabinet=Empty_DeviceBehfa_Cabinet_Interface()
    this.Selected_DataList_Cabinet_Swicher=0
  }

  //#region DeviceBehfa List

  page: number = 0
  Filter_Description:string=''
  Filter_Manufacturer:string=''
  Filter_Model:string=''
  Filter_Code:string=''
  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
  Data_Change_Operaion:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  Data_Change_Operaion_Edit:number=0

  Set_Change_Operaion(item:DeviceBehfa_Interface){
    this.Data_Change_Operaion=item
  }

  OnBack_Change_Operaion(item:DeviceBehfa_Interface){
    this.Data_Change_Operaion=Empty_DeviceBehfa_Interface()
  }

  Set_Change_Operaion_Edit(item:number){
    this.Data_Change_Operaion_Edit=item
  }

  OnBack_Change_Operaion_Edit(item:DeviceBehfa_Interface){
    this.Data_Change_Operaion_Edit=0
  }
  //#endregion

}
